import React, { useState, useCallback } from 'react'
import './playground.css'
import './games/games.css'
import PrisonersDilemma from './games/PrisonersDilemma'
import KuhnPoker from './games/KuhnPoker'
import ColonelBlotto from './games/ColonelBlotto'

const GAMES = {
  'prisoners-dilemma': {
    title: 'Trust & Betrayal',
    subtitle: 'Iterated Prisoner’s Dilemma',
    description:
      'Twelve rounds against an opponent that models how you respond to it, then weighs this round’s payoff against the regime your move creates.',
    Component: PrisonersDilemma,
  },
  'kuhn-poker': {
    title: 'Kuhn Poker',
    subtitle: 'Solved betting game',
    description:
      'Three cards, one bet, and an opponent playing the exact Nash equilibrium. See how far bluffing gets you against a strategy that cannot be exploited.',
    Component: KuhnPoker,
  },
  'colonel-blotto': {
    title: 'Colonel Blotto',
    subtitle: 'Resource allocation duel',
    description:
      'Split 100 troops across five fronts. The AI runs fictitious play against your history — fall into a pattern and it will solve for the counter.',
    Component: ColonelBlotto,
  },
}

const AIPlayground = () => {
  const [selected, setSelected] = useState('prisoners-dilemma')
  const [ledger, setLedger] = useState([])

  const record = useCallback((entry) => {
    setLedger((l) => [{ ...entry, at: Date.now() }, ...l].slice(0, 8))
  }, [])

  const { title, subtitle, description, Component } = GAMES[selected]

  const tally = ledger.reduce(
    (acc, e) => ({ ...acc, [e.result]: (acc[e.result] || 0) + 1 }),
    { win: 0, loss: 0, draw: 0 }
  )

  return (
    <section id="playground" className="playground">
      <h5>Play against the machine</h5>
      <h2>Game Theory Playground</h2>

      <div className="container playground__container">
        <div className="demo-selector">
          {Object.entries(GAMES).map(([key, g]) => (
            <button
              key={key}
              className={`demo-btn ${selected === key ? 'active' : ''}`}
              onClick={() => setSelected(key)}
            >
              {g.title}
            </button>
          ))}
        </div>

        <div className="demo-content">
          <div className="demo-header">
            <h3>{title}</h3>
            <span className="demo-tag">{subtitle}</span>
            <p>{description}</p>
          </div>

          {/* Remount on switch so each game starts clean */}
          <Component key={selected} onFinish={record} />
        </div>

        <div className="ledger">
          <div className="ledger__head">
            <h4>Session record</h4>
            <div className="ledger__tally">
              <span className="positive">{tally.win}W</span>
              <span className="muted">{tally.draw}D</span>
              <span className="negative">{tally.loss}L</span>
            </div>
          </div>
          {ledger.length === 0 ? (
            <p className="note">Nothing played yet — results land here as you go.</p>
          ) : (
            <ul className="ledger__list">
              {ledger.map((e, i) => (
                <li key={e.at + '-' + i}>
                  <span className="ledger__game">{e.game}</span>
                  <span className="ledger__detail">{e.detail}</span>
                  <span className={`ledger__result ledger__result--${e.result}`}>{e.result}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </section>
  )
}

export default AIPlayground
